export enum ErrorCode {
    cssChunk = 'CSS_CHUNK_LOAD_FAILED',
}
